import {
  SYSTEM_ERROR_OCCURED,
  CLEAN_ERRORS
} from "./types/serviceNotificationActionTypes";

export function serviceErrorOccured(error) {
  return {
    type: SYSTEM_ERROR_OCCURED,
    error
  };
}

export function cleanErrors() {
  return {
    type: CLEAN_ERRORS
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/serviceNotificationActions.js